// src/components/TransactionUploader/FileInput.tsx
import React, { ChangeEvent, useState } from 'react';
import {
  Wrapper, Label, HiddenInput, FileName, ErrorText
} from './TransactionUploader.styles';

interface FileInputProps {
  onFileSelected: (file: File | null) => void;
  parseError: string | null;
}

const FileInput: React.FC<FileInputProps> = ({ onFileSelected, parseError }) => {
  const [fileName, setFileName] = useState('Nessun file selezionato');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFileName(file ? file.name : 'Nessun file selezionato');
    onFileSelected(file);
  };

  return (
    <Wrapper>
      <Label htmlFor="csv-input">Seleziona file (CSV / XLSX)</Label>
      <HiddenInput
        id="csv-input"
        type="file"
        accept=".csv,.xlsx,.xls"
        onChange={handleChange}
        aria-label="Seleziona file CSV o XLSX"
      />
      <FileName>{fileName}</FileName>
      {parseError && <ErrorText role="alert">{parseError}</ErrorText>}
    </Wrapper>
  );
};

export default FileInput;
